/// <reference types="vite/client" />
import { queryOptions, useQuery, UseQueryResult } from '@tanstack/react-query';
import useLoan from '../useLoan/useLoan';
import { NextPayment } from 'merchant-api/types';
import { spiceroad } from '..';

export interface PaymentProps {
  loanPaymentLoading: boolean;
  loanPayment: NextPayment | null | undefined;
  loanPaymentError: any;
  query: UseQueryResult<NextPayment>;
}

const getTLNextPayment = (loanId: string) =>
  spiceroad
    .get<NextPayment>(`/v1/loans/${loanId}/payment/next`)
    .then((res) => res.data);

export const getTLNextPaymentOpts = (loanId: string) =>
  queryOptions<NextPayment>({
    queryKey: ['loanPayment', loanId],
    queryFn: () => getTLNextPayment(loanId),
  });

export function getTLPayment(): PaymentProps {
  const { activeTL, loan, loanLoading, loanError } = useLoan();
  const loanId = activeTL ? loan.id : null;
  const query = useQuery({
    ...getTLNextPaymentOpts(loanId!),
    enabled: !!loanId,
  });
  const { data, error, isLoading } = query;
  return {
    loanPayment: data,
    loanPaymentLoading: isLoading || loanLoading,
    loanPaymentError: error || loanError,
    query,
  };
}

export default getTLPayment;
